/* eslint-disable @typescript-eslint/no-explicit-any */
import { FaSearch } from 'react-icons/fa';
import { globalEnv } from '../../../config/baseConfig';

import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

import { CSSTransition } from 'react-transition-group';
import LazyImage from '../../Utils/Components/imageComponent';
import axios from 'axios';
import { useTypedSelector } from '../../../hooks/useTypeSelector';

type modalProps = {
	visible: boolean;
	isChanged: boolean;
	setIsChanged: (isChanged: boolean) => void;
	setModalOpen: (isOpen: boolean) => void;
	isWarnModalOpen: boolean;
	setIsWarnModalOpen: (isOpen: boolean) => void;
};

export const ContribModal: FunctionComponent<modalProps> = (props) => {
	return (
		<CSSTransition
			in={props.visible}
			timeout={400}
			unmountOnExit
			classNames="modal"
		>
			{(state) => (
				<div
					id="defaultModal"
					aria-hidden="true"
					className="overflow-y-hidden overflow-x-hidden backdrop-blur-md fixed z-20
							  w-full inset-0 h-modal h-full"
				>
					<div className="absolute inset-0 w h-full w-full opacity-50 bg-black" />
				</div>
			)}
		</CSSTransition>
	);
};

function ChangeTopicCreator({
	buttonRef,
	creator,
	setCreator,
	isModalOpen,
	setIsModalOpen,
	setIsChanged
}: {
	buttonRef: any;
	creator: any;
	setCreator: (creator: any) => void;
	isModalOpen: boolean;
	setIsModalOpen: (ismodalOpen: boolean) => void;
	setIsChanged: (ismodalOpen: boolean) => void;
}) {
	const [searchTerm, setSearchTerm] = useState('');
	const [editorsList, setEditorsList] = useState([]);
	const [page, setPage] = useState(1);
	const [isShown, setIsShown] = useState(false);
	const [noUsersFound, setNoUsersFound] = useState(false);

	const [searchResultsRef, setSearchResultsRef] = useState(useRef());
	const inputRef: any = useRef(null);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			setNoUsersFound(false);
			fetchEditorsList(searchTerm);
		}, 600);

		return () => clearTimeout(delayDebounceFn);
	}, [searchTerm]);

	async function fetchEditorsList(searchTerm: string) {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		try {
			const { data } = await axios.get(
				`${globalEnv.BASE_URL}/editor/search-editors?filter=${searchTerm}&page=${page}`,
				config
			);
			if (data.meta.pages < page) {
				setPage(1);
			}
			setEditorsList(data.users);
		} catch (e) {
			setEditorsList([]);
			setNoUsersFound(true);
		}
	}

	useDetectClickOut(
		isShown,
		isModalOpen,
		setIsModalOpen,
		buttonRef,
		inputRef,
		searchResultsRef
	);

	return (
		<div className="" ref={inputRef}>
			<div
				className="relative min-w-300 flex items-center justify-start
                    bg-gray-400 dark:bg-gray-600 text-gray-500 h-9 ml-0 mr-0 
                      rounded-md shadow-md transition duration-500 ease-in-out"
			>
				<input
					className="w-full font-sans font-semibold bg-transparent outline-none mx-2
                        text-gray-800 dark:text-white placeholder-gray-500 pl-1 rounded"
					type="text"
					placeholder={'Choose a new creator'}
					onFocus={() => setIsShown(true)}
					onChange={(e) => {
						setSearchTerm(e.target.value);
					}}
					value={searchTerm}
				/>
				<FaSearch
					size="18"
					className="text-purple-600 my-auto cursor-pointer mx-2"
					onClick={() => {
						setNoUsersFound(false);
						fetchEditorsList(searchTerm);
					}}
				/>
			</div>
			{isShown &&
				(noUsersFound ? (
					<div className="absolute z-50 top-10 bg-gray-300 mt-2 w-full h-fit flex flex-col items-start rounded-lg ">
						<a className="w-full h-14 flex items-start" target="_blank">
							<p className="ml-2 hover:bg-gray-400">No users </p>
						</a>
					</div>
				) : (
					<EditorElem
						editorsList={editorsList}
						setMyRef={setSearchResultsRef}
						creator={creator}
						setCreator={setCreator}
						setIsChanged={setIsChanged}
					/>
				))}
		</div>
	);
}

function EditorElem({
	editorsList,
	setMyRef,
	creator,
	setCreator,
	setIsChanged
}: {
	editorsList: any[];
	setMyRef: (ref: any) => void;

	creator: any;
	setCreator: (contibutors: any) => void;
	setIsChanged: (ismodalOpen: boolean) => void;
}) {
	const nodeRef: any = useRef(null); // optional
	useEffect(() => {
		setMyRef(nodeRef);
	}, [nodeRef]);

	const chooseEditorAsCreator = (editor: any) => {
		setCreator(editor);
		setIsChanged(true);
	};

	const checkIfEditorIsTheCreator = (editor: any): boolean => {
		if (creator != null) return creator._id === editor._id;
		return false;
	};

	return (
		<div
			ref={nodeRef}
			className="absolute group z-50 top-10 bg-gray-300 dark:bg-gray-700 mt-2 w-full h-fit flex flex-col items-start rounded-lg overflow-hidden "
		>
			{editorsList.slice(0, 15).map((editor: any, key) => {
				if (!checkIfEditorIsTheCreator(editor))
					return (
						<div
							className="w-full h-full flex items-start align-middle px-4 py-3 dark:hover:bg-gray-600 hover:bg-gray-400 cursor-pointer"
							onClick={() => chooseEditorAsCreator(editor)}
						>
							<div className="mr-2">
								<LazyImage
									photo={
										editor.photo != null
											? editor.photo
											: `https://api.dicebear.com/7.x/bottts/svg?seed=${editor.username}`
									}
									dimesnions={'25'}
									loaderDimesnions={23}
								/>
							</div>
							<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white ">
								{editor.username}
							</div>
						</div>
					);
			})}
		</div>
	);
}

function useDetectClickOut(
	isShown: boolean,
	ismodalOpen: boolean,
	setIsmodalOpen: (show: boolean) => void,
	buttonRef: any,
	triggerRef: any,
	nodeRef: any
) {
	const handleClickOutside = (event: any) => {
		if (
			triggerRef.current &&
			!triggerRef.current.contains(event.target) &&
			buttonRef.current &&
			!buttonRef.current.contains(event.target)
		) {
			if (isShown) {
				if (nodeRef.current && !nodeRef.current.contains(event.target))
					return setIsmodalOpen(!ismodalOpen);
			}
			return setIsmodalOpen(!ismodalOpen);
		}
	};
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	});
	return {
		triggerRef,
		nodeRef
	};
}

export default ChangeTopicCreator;
